export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "en",
    "resource": {
      "Please check the required": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please check the required"])}
    }
  })
}
